<template>
  <div>
    <div class="classBnaer" v-loading="loading" element-loading-text="加载中...">
      <div style="text-align: center; font-size: 28px">请选择需要练习的题型</div>

      <div style="margin-top: 50px; display: flex; margin-bottom: 30px">
        <div style="font-size: 16px; line-height: 40px; margin-right: 20px">练习科目</div>
        <el-select @change="handlKm" style="width: 865px" v-model="form.trainingSubjectId" placeholder="请选择练习科目">
          <el-option
            v-for="item in columns"
            :key="item.trainingSubjectId"
            :label="item.trainingSubject"
            :value="item.trainingSubjectId"
          ></el-option>
        </el-select>
      </div>

      <div class="tk" v-for="(item, index) in tiKuList" :key="index">
        <div class="lx">
          <div>{{ item.qtypeName }}({{ item.questionNum }})</div>
          <div style="color: #2878ff; cursor: pointer" @click="goPractice(item)">开始练习</div>
        </div>
      </div>
      <div v-if="zxList.length">
        <div style="text-align: center; font-size: 20px; margin: 50px 0 20px 0; padding: 10px 20px; background: #2878ff; color: #fff">
          甄选题库
        </div>
        <div class="tk" v-for="(item, index) in zxList" :key="index">
          <div class="lx">
            <div>{{ item.qtypeName }}({{ item.questionNum }})</div>
            <div style="color: #2878ff; cursor: pointer" @click="goPractice(item)">开始练习</div>
          </div>
        </div>
      </div>
      <div class="tk" v-if="tiKuList == null">
        <div class="lx" style="text-align: center">暂无题库数据~</div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { doQuestionBankDetail } from '@/api/study.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      columns: [],
      text: [],
      examId: [],
      form: {},
      tiKuList: [],
      zxList: [], //甄选题库
      loading: false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //去练习
    goPractice(item) {
      console.log(item);
      window.open(
        this.$router.resolve({
          path:
            '/tklx?id=' +
            item.qtypeId +
            '&codeId=' +
            item.codeId +
            '&qtypeName=' +
            item.qtypeName +
            '&qtypeId=' +
            item.qtypeId +
            '&orderId=' +
            item.orderId +
            '&classCodeId=' +
            item.classCodeId
        }).href,
        '_blank'
      );
    },
    //
    handlKm(e) {
      this.loading = true; // 开loading
      doQuestionBankDetail({ trainSubjectId: e })
        .then(res => {
          this.tiKuList = res.data.data.questionNumList;
          if (this.tiKuList !== null) {
            this.tiKuList.forEach(v => {
              v.orderId = res.data.data.orderId;
            });
          }
        })
        .finally(() => {
          this.loading = false; // 关loading
        });
      this.$forceUpdate();
    },
    //获取
    doQuestionBankDetail(trainSubjectId) {
      this.loading = true; // 开loading
      doQuestionBankDetail({ trainSubjectId: trainSubjectId })
        .then(res => {
          let data = {
            orderId: res.data.data.orderId,
            trainingSubject: res.data.data.trainingSubject,
            trainingSubjectId: res.data.data.trainingSubjectId
          };
          this.columns = [data, ...res.data.data.trainingSubjectList];
          this.tiKuList = res.data.data.questionNumList;
          this.zxList = res.data.data.zxQuestionNumList;
          if (this.tiKuList !== null) {
            this.tiKuList.forEach(v => {
              v.orderId = res.data.data.orderId;
            });
          }
          if (this.zxList !== null) {
            this.zxList.forEach(v => {
              v.orderId = res.data.data.orderId;
            });
          }
          this.form.trainingSubjectId = this.columns[0].trainingSubjectId;
        })
        .finally(() => {
          this.loading = false; // 关loading
        });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.doQuestionBankDetail();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.classBnaer {
  width: 1170px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  min-height: 748px;
  .tk {
    padding: 0 10px;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    border: 1px dashed #ccc;
    margin-bottom: 10px;
    .lx {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
